/* eslint-disable import/prefer-default-export */
export const DEFAULT_WALL_AND_FLOOR_OPACITY = 0.1;

export const FULL_WALL_AND_FLOOR_OPACITY = 1;

export const ON_LOAD_INITIAL_FLOOR_LEVEL_VIEW = "2";
